import { UseLoadingReturn } from "@/hooks/use-loading";
import orderService from "@/services/order.service";

import useRemove from "../../use-remove";

export type UseRemovePaymentReturn = {
  removePayment: (props: {
    orderId: number;
    paymentId: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
  }) => Promise<void>;
} & UseLoadingReturn;

const useRemovePayment = (): UseRemovePaymentReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (_id, secondaryId) => {
      if (secondaryId === undefined) throw new Error("Payment ID is missing");

      return orderService.deletePayment(_id, secondaryId);
    },
  });

  const removePayment = async ({
    orderId,
    paymentId,
    successMessage,
    errorMessage,
    onSuccess,
  }: {
    orderId: number;
    paymentId: number;
    successMessage?: string;
    errorMessage?: string;
    onSuccess?: () => void;
  }) => {
    await remove({
      _id: orderId,
      secondaryId: paymentId,
      onSuccess: onSuccess,
      successMessage: successMessage,
      errorMessage: errorMessage,
    });
  };

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    removePayment,
  };
};

export default useRemovePayment;
